import { FC, memo } from 'react';
import { isNil } from 'lodash';
import { useTranslation } from 'react-i18next';
// Import Types
import type { BonusDetail } from 'types';
// Import Components
import DataTable from 'components/common/DataTable';
// Import Constants
import { BonusTypesLabels, l } from 'constants/common';
// Import Configs
import { DataTableColumnsConfigs } from './configs';

interface Props {
    type?: number;
    bonusDetails?: Nullable<BonusDetail[]>;
}

const BonusInfo: FC<Props> = ({ bonusDetails, type }) => {
    const { t } = useTranslation();

    const { columns } = DataTableColumnsConfigs(t, type);

    const getDataTableName = () => (
        <span>
            {t(
                [
                    BonusTypesLabels.NftVoucherBonus,
                    BonusTypesLabels.WonderWheelSpin,
                    BonusTypesLabels.FreeSpin,
                    BonusTypesLabels.LoyaltyPoint,
                ].includes(type ?? -1)
                    ? l.Counts
                    : l.Amounts,
            )}
        </span>
    );

    const mapBonusDetails = (data) => {
        return (
            data?.map(({ Id, CurrencyCode, MaxAmount, MinAmount }, index) => ({
                index: index,
                actionBar: false,
                dragDisable: true,
                hasHover: true,
                data: {
                    dataKey: Id,
                    index: index,
                    CurrencyCode,
                    MaxAmount,
                    MinAmount,
                },
            })) ?? []
        );
    };

    const getTableColumns = () => {
        return columns;
    };

    return (
        <DataTable
            key="BonusInfo"
            columnKey="dataKey"
            rowKey="index"
            name={getDataTableName()}
            data={mapBonusDetails(bonusDetails)}
            dataCount={bonusDetails?.length ?? 0}
            columns={getTableColumns()}
            isLoading={isNil(bonusDetails)}
            withPagination={false}
            withPageSelector={false}
            withHeaderActions={false}
        />
    );
};

export default memo(BonusInfo);
